import {
    createPromotionalCard,
    IPromotionalCardBusinessLogic,
    PromotionalCard,
} from '@vfde-brix/ws10/promotional-card';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { startAppListening } from 'Container/App/listener';
import { CASHBACK_PROMOTIONAL_CARD_CONTAINER } from 'Container/App/constants';
import { selectCustomerConfig } from 'Container/App/slice';

const mountPromotionalCard = (id: string, business: IPromotionalCardBusinessLogic = NO_PATTERN_BUSINESS_LOGIC): PromotionalCard | null => {
    const promotionalCard = createComponentById(createPromotionalCard, id, business);

    if (!promotionalCard) {
        return null;
    }

    return promotionalCard;
};

/**
 * Mount cashback promotional card
 */
export const mountCashbackPromotionalCard = (): PromotionalCard | null => {
    const promotionalCard = mountPromotionalCard(CASHBACK_PROMOTIONAL_CARD_CONTAINER);

    promotionalCard && startAppListening({
        predicate: (_action, currentState, previousState) =>
            selectCustomerConfig(currentState).hasCashback !== selectCustomerConfig(previousState).hasCashback,
        effect: (_action, api) => {
            const properties = promotionalCard!.getProperties()!;

            const { hasCashback } = selectCustomerConfig(api.getState());

            const { containerFormSelectionControl, stdConfirmationText } = properties;
            const checkbox = containerFormSelectionControl!.items[0];

            hasCashback && promotionalCard!.update({
                containerFormSelectionControl: {
                    ...containerFormSelectionControl!,
                    items: [{
                        ...checkbox,
                        optState: 'checked',
                        txtLabelText: `<p>${stdConfirmationText}</p>`,
                    }],
                },
            });
        },
    });

    return promotionalCard;
};
